import React from 'react';
import { Button } from '../../../components/ui';
import { useResubscribeManually } from '../../../mutation/unsubscribe';

type Props = {
  id: number,
};

export default function ResubscribeButton({ id }: Props) {
  const { mutate, isLoading } = useResubscribeManually();
  return (
    <Button
      className="email__resubscribe-btn"
      disabled={isLoading}
      loading={isLoading}
      type="button"
      onClick={() => mutate({ id })}
    >
      re-subscribe
    </Button>
  );
}
